var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,512) scale(0.1,-0.1)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2410 4704 c-575 -73 -1035 -476 -1175 -1029 -35 -135 -48 -301 -35 -426 49 -478 404 -1070 1053 -1758 74 -79 165 -170 202 -202 56 -51 72 -59 105 -59 49 0 99 42 299 253 594 626 948 1185 1047 1652 22 107 22 320 0 444 -87 482 -415 874 -876 1048 -130 50 -263 74 -430 78 -85 2 -171 1 -190 -1z m289 -923 c152 -47 264 -167 306 -328 67 -257 -107 -518 -374 -563 -144 -24 -287 24 -395 133 -143 143 -176 349 -85 530 99 196 336 294 548 228z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1675 1622 c-273 -96 -468 -232 -546 -383 -31 -59 -34 -71 -34 -154 0 -80 3 -97 30 -150 39 -78 147 -186 248 -249 536 -334 1601 -369 2239 -74 176 82 325 208 383 323 27 53 30 70 30 150 0 82 -3 96 -33 153 -37 71 -132 171 -212 224 -107 70 -266 142 -397 181 l-52 16 -105 -119 -105 -118 66 -38 c234 -137 208 -323 -63 -450 -151 -71 -331 -104 -564 -104 -233 0 -413 33 -564 104 -271 127 -297 313 -63 450 l66 38 -106 119 c-58 65 -106 119 -107 119 0 0 -50 -17 -111 -38z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pin.11fcefbd.svg";
export { ForwardRef as ReactComponent };